import { UseFormReturn } from "react-hook-form"
import { WidgetConfigurationFormType } from ".."
import { LocalizedTexts } from "./LocalizedTexts"

type OpeningMessageProps = {
  form: UseFormReturn<WidgetConfigurationFormType>
}

export const OpeningMessage = ({ form }: OpeningMessageProps) => (
  <LocalizedTexts form={form} name="openingMessage" />
)
